import { useState } from 'react';
import { useQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { SUCCESSFUL_EXECUTION_RESULTS_FIELDNAME, FAILED_EXECUTION_RESULTS_FIELDNAME, GET_SUCCESSFUL_ASSOCIATED_EXECUTION_RESULTS, GET_FAILED_ASSOCIATED_EXECUTION_RESULTS } from 'automation-ui-log-events/api-client/queries/AssociatedExecutionResultsQueries';
import AssociatedExecutionStates from 'automation-ui-log-events/records/ExecutionResult/AssociatedExecutionStates';
import { getEnrollmentId, getActionExecutionIndex } from 'automation-ui-log-events/records/LogEvent/utils';
import { getExecutionCounts } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
import { pickFromQuery } from 'automation-ui-log-events/components/execution-results/utils/pickFromQuery';
import ResultsTabs from 'automation-ui-log-events/components/execution-results/components/ResultsTabs';
import LoadMoreButton from 'automation-ui-log-events/components/execution-results/components/LoadMoreButton';
import SuccessfulExecutionResults from 'automation-ui-log-events/components/execution-results/components/SuccessfulExecutionResults';
import FailedExecutionResults from 'automation-ui-log-events/components/execution-results/components/FailedExecutionResults';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogEventExecutionResultsTable = ({
  flowObjectTypeId,
  logEvent
}) => {
  const {
    failCount
  } = getExecutionCounts(logEvent);
  const initialTab = failCount ? AssociatedExecutionStates.FAILURE : AssociatedExecutionStates.SUCCESS;
  const [tab, setTab] = useState(initialTab);
  const enrollmentId = getEnrollmentId(logEvent);
  const actionExecutionIndex = getActionExecutionIndex(logEvent);
  const actionType = getIn(['action', 'actionType'], logEvent);
  const successfulResultsQuery = useQuery(GET_SUCCESSFUL_ASSOCIATED_EXECUTION_RESULTS, {
    skip: tab !== AssociatedExecutionStates.SUCCESS,
    variables: {
      enrollmentId,
      actionExecutionIndex
    }
  });
  const failedResultsQuery = useQuery(GET_FAILED_ASSOCIATED_EXECUTION_RESULTS, {
    skip: tab !== AssociatedExecutionStates.FAILURE,
    variables: {
      enrollmentId,
      actionExecutionIndex
    }
  });
  const dataByTab = {
    [AssociatedExecutionStates.SUCCESS]: pickFromQuery(SUCCESSFUL_EXECUTION_RESULTS_FIELDNAME)(successfulResultsQuery),
    [AssociatedExecutionStates.FAILURE]: pickFromQuery(FAILED_EXECUTION_RESULTS_FIELDNAME)(failedResultsQuery)
  };
  const dataForTab = dataByTab[tab];
  const {
    loading,
    fetchMore,
    error
  } = dataForTab;
  const nextPage = getIn(['next', 'after'], dataForTab.getPaging());
  const fieldName = tab === AssociatedExecutionStates.SUCCESS ? SUCCESSFUL_EXECUTION_RESULTS_FIELDNAME : FAILED_EXECUTION_RESULTS_FIELDNAME;
  return /*#__PURE__*/_jsxs(View, {
    paddingBlock: "200",
    as: "div",
    children: [/*#__PURE__*/_jsx(ResultsTabs, {
      tab: tab,
      handleTabChange: setTab
    }), tab === AssociatedExecutionStates.FAILURE ? /*#__PURE__*/_jsx(FailedExecutionResults, {
      actionType: actionType,
      error: error,
      executionResults: dataForTab.getResults(),
      flowObjectTypeId: flowObjectTypeId,
      loading: loading,
      logEvent: logEvent
    }) : /*#__PURE__*/_jsx(SuccessfulExecutionResults, {
      actionType: actionType,
      error: error,
      executionResults: dataForTab.getResults(),
      flowObjectTypeId: flowObjectTypeId,
      loading: loading
    }), /*#__PURE__*/_jsx(LoadMoreButton, {
      loading: loading,
      fetchMore: fetchMore,
      nextPage: nextPage,
      fieldName: fieldName
    })]
  });
};
export default LogEventExecutionResultsTable;